export enum NotificationType {
  ReleaseNotes = 'release-notes',
  Outage = 'outage',
  ImportantUpdate = 'important-update',
  General = 'general',
}

export interface INotification {
  id: number
  title: string
  content: string // HTML from ngx-quill editor, DOMPurify sanitized
  type: NotificationType
  publishedOn: Date
  modifiedOn?: Date
  isDismissed: boolean
}
